import { Region } from '@components/common/constants';

export const BACKEND_BASE_URL = {
  [Region.US]:
    process.env.REACT_APP_BACKEND_URL ||
    process.env.REACT_APP_BACKEND_URL_US ||
    'http://localhost:5050',
  [Region.EU]: process.env.REACT_APP_BACKEND_URL_EU || 'http://localhost:5051',
  [Region.IN]: process.env.REACT_APP_BACKEND_URL_IN || 'http://localhost:5052',
};
export const WEB_APP_URL = process.env.REACT_APP_WEB_URL || 'http://localhost:3000';

const US_ACTIVATION_API_URL = process.env.REACT_APP_US_ACTIVATION_API || 'http://localhost:5110';

export const ACTIVATION_HOST_URL = {
  [Region.US]: US_ACTIVATION_API_URL,
  [Region.EU]: process.env.REACT_APP_EU_ACTIVATION_API || US_ACTIVATION_API_URL,
  [Region.IN]: process.env.REACT_APP_IN_ACTIVATION_API || US_ACTIVATION_API_URL,
};

export const disableCognito = process.env.REACT_APP_DISABLE_COGNITO === 'true';
export const disableAnalytics = process.env.REACT_APP_DISABLE_ANALYTICS === 'true' || false;
export const disableSSO = process.env.REACT_APP_DISABLE_SSO === 'true';

export const DATADOG_APP_ID = process.env.REACT_APP_DATADOG_APP_ID || '';
export const DATADOG_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_VERSION || '';
export const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

export const TABLE_VIRTUALIZATION_THRESHOLD = parseInt(
  process.env.REACT_APP_TABLE_VIRTUALIZATION_THRESHOLD || '80',
  10,
);

// ts-prune-ignore-next
export const userPoolMCPClientId = process.env.REACT_APP_AWS_USER_POOL_MCP_CLIENT_ID || '';

export const awsConfig = {
  Auth: {
    region: process.env.REACT_APP_AWS_REGION || '',
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID || '',
    // We need the mcp client id of the mcp
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID || '',
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN_ENDPOINT || '',
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: `${WEB_APP_URL}/signup`,
      redirectSignOut: `${WEB_APP_URL}/signup`,
      responseType: 'code',
    },
  },
};

export const SLACK_APP_CLIENT_ID =
  process.env.REACT_APP_SLACK_APP_CLIENT_ID || '611722233910.6013277261767';

export const LIVE_EVENT_CAPTURE_TIME_IN_MIN = parseInt(
  process.env.REACT_APP_LIVE_EVENT_CAPTURE_TIME_IN_MIN || '5',
  10,
);

export const ASYNC_API_MAX_POLL_INTERVAL = parseInt(
  process.env.REACT_APP_ASYNC_API_MAX_POLL_INTERVAL || '10000',
  10,
);

export const ASYNC_API_TIMEOUT = parseInt(process.env.REACT_APP_ASYNC_API_TIMEOUT || '660000', 10);

export const LOCAL_FEATURE_FLAGS = {
  VDM_NEXT: process.env.REACT_APP_VDM_NEXT || 'false',
  RS360_ENABLE_WHT: process.env.REACT_APP_RS360_ENABLE_WHT || 'false',
  ENABLE_PROFILES_UIV1: process.env.REACT_APP_ENABLE_PROFILES_UIV1 || 'false',
  ENABLE_COHORT_AUDIENCE: process.env.REACT_APP_ENABLE_COHORT_AUDIENCE || 'false',
  ENABLE_PROFILES_COPILOT: process.env.REACT_APP_ENABLE_PROFILES_COPILOT || 'false',
  ENABLE_PROFILES_IN_APP_COPILOT: process.env.REACT_APP_ENABLE_PROFILES_IN_APP_COPILOT || 'false',
  ENABLE_DATA_GRAPH_AUDIENCES: process.env.REACT_APP_ENABLE_DATA_GRAPH_AUDIENCES || 'false',
  ENABLE_DATA_GRAPH: process.env.REACT_APP_ENABLE_DATA_GRAPH || 'false',
  ENABLE_AUDIENCES_V1: process.env.REACT_APP_ENABLE_AUDIENCES_V1 || 'false',
  ENABLE_CODE_SERVER_TOKEN_EXCHANGE:
    process.env.REACT_APP_ENABLE_CODE_SERVER_TOKEN_EXCHANGE || 'false',
  ENABLE_NEW_PERMISSIONS_MODEL: process.env.REACT_APP_ENABLE_NEW_PERMISSIONS_MODEL || 'false',
  ENABLE_TRANSFORMATION_DRAFT_MODE:
    process.env.REACT_APP_ENABLE_TRANSFORMATION_DRAFT_MODE || 'false',
  ENABLE_TRANSFORMATIONS_TESTS: process.env.REACT_APP_ENABLE_TRANSFORMATIONS_TESTS || 'false',
};

export const amplitudeEngagementConfig = {
  apiKey: process.env.REACT_APP_AMPLITUDE_ENGAGEMENT_API_KEY || '',
};

export const flagsmithConfig = {
  environmentKey: process.env.REACT_APP_FLAGSMITH_ENV_KEY || '',
};

export const freeTierBlockedEmailDomains = (
  process.env.REACT_APP_FREE_TIER_BLOCKED_EMAIL_DOMAINS || ''
)
  .split(',')
  .map((s) => s.trim())
  .filter((i) => i);

export const IS_ADMIN_WEB_APP = process.env.REACT_APP_IS_ADMIN_WEB_APP === 'true' || false;
